import states from "./state-list";

let canada = [
    { name: "Alberta", abbreviation: "AB" },
    { name: "British Columbia", abbreviation: "BC" },
    { name: "Manitoba", abbreviation: "MB" },
    { name: "New Brunswick", abbreviation: "NB" },
    { name: "Newfoundland and Labrador", abbreviation: "NL" },
    { name: "Nova Scotia", abbreviation: "NS" },
    { name: "Ontario", abbreviation: "ON" },
    { name: "Prince Edward Island", abbreviation: "PE" },
    { name: "Quebec", abbreviation: "QC" },
    { name: "Saskatchewan", abbreviation: "SK" },
];

let otherCountries = [{ name: "Mexico", abbreviation: "MX" }];

export default [
    { country: "United States", lanes: states},
    { country: "Canada", lanes: canada},
    { country: "Other", lanes: otherCountries }
]